import Spinner from './Spinner';
import Text from './Text';
import Button from './Button';
import styles from './styles.scss';

export { Spinner, Text, Button };

type LoadingFunc = () => boolean;
type LoadingType = LoadingFunc | boolean;
export const isLoading = (loading: LoadingType = false) =>
  typeof loading === 'function' ? loading() : loading;

export interface LoaderProps {
  loading?: LoadingType;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export const FullPageSpinner = (props: LoaderProps) => (
  <Spinner {...props} className={styles.fullPage} />
);

export default Spinner;
